// extracted by mini-css-extract-plugin
module.exports = {"blurHashWrapper":"ob_GS4vMr","pictureTag":"ob_h8bUb7","hasValidAttribution":"ob_QZnlbY","fitWidth":"ob_yMld6l","mediaAttribution":"ob_VLrFXz","pictureWithAttribution":"ob_zaebRB"};